import { type RouteRecordRaw } from '@bv/router';
import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

import { MODULES_ORDER_ARRAY, PERMISSION_DEPENDENCIES } from './constants';

const settingsBreadcrumbs = generateBreadcrumbs({
  label: 'settings.settings',
  route: { name: 'settings' },
});

export const rolesRoute: RouteRecordRaw = {
  path: 'roles',
  name: 's-roles',
  meta: {
    breadcrumbs: settingsBreadcrumbs({
      label: 'settings.nav.roles_and_permissions',
      route: { name: 's-roles-list' },
    }),
  },
  children: [
    {
      path: '',
      name: 's-roles-list',
      component: () => import('@/components/Settings/Roles/RolesList/RolesList.vue'),
      meta: { permissions: 'read-roles-&-permissions' },
    },
    {
      path: '',
      component: () => import('@bv/features/settings/roles/BvRoleForm.vue'),
      props: {
        modulesOrder: MODULES_ORDER_ARRAY,
        dependencies: PERMISSION_DEPENDENCIES,
      },
      children: [
        {
          path: 'add',
          name: 's-roles-add',
          meta: { permissions: 'write-roles-&-permissions' },
        },
        {
          path: 'edit/:roleId',
          name: 's-roles-edit',
          meta: { permissions: 'update-roles-&-permissions' },
        },
      ] as unknown as RouteRecordRaw[],
    },
  ],
};
